import ApiService from './api.service'

const PromoService = {


	/**
	 * Store Promo to product
	 * @param data
	 * @returns {*}
	 */
	addOrUpdateAllItems: function (data) {
		return ApiService.post(`/promotion/add-or-update/all-items-in-department`, data)
	},
	addPromo: function (data) {
		return ApiService.post(`/promotion/add-or-update`, data)
	},
	addSecondPromo:function(data) {
		return ApiService.post(`/promotion/save-buy-x-get-y`, data)
	},
	buyXForPagination(promotionId, page, limit) {
		return ApiService.post(`/promotion/buy-x-for-pagination?promotionId=${promotionId}&page=${page}&limit=${limit}`)
	},
	getYForPagination(promotionId, page, limit) {
		return ApiService.post(`/promotion/get-y-for-pagination?promotionId=${promotionId}&page=${page}&limit=${limit}`)
	},
	savePromotionDoubleArray(data, searchForm, check) {
		return ApiService.post(`/promotion/list-for-promotion?page=${searchForm.page}&limit=${searchForm.limit}&check=${check}`, data)
	},
	promotionUpdateforPagination(promotionId,searchForm){
		return ApiService.post(`/promotion/list-pagination?promotionId=${promotionId}&page=${searchForm.page}&limit=${searchForm.limit}`)
	},
	simplePromotion(promotionId,searchForm){
		return ApiService.post(`/promotion/simple-promotion?promotionId=${promotionId}&page=${searchForm.page}&limit=${searchForm.limit}`)
	},
	updateCollectPlusArray(data, searchForm) {
		return ApiService.post(`/promotion/plus-map?page=${searchForm.page}&limit=${searchForm.limit}`, data)
	},
	updateCollectMinusArray(data, searchForm) {
		return ApiService.post(`/promotion/minus-map?page=${searchForm.page}&limit=${searchForm.limit}`, data)
	},
	updateFinished(data) {
		return ApiService.post(`/promotion/update`, data)
	},
	buyXgetYUpdateFinished(data) {
		return ApiService.post(`/promotion/update-buy-x-get-y`, data)
	},

	/**
	 * List all promos
	 * @returns {*}
	 */
	getOneTimeDiscountDocs: function (data) {
		return ApiService.post(`/warehouse-document/search/discount/documents`, data)
	},
	getAllPromos: function (data) {
		return ApiService.post(`/promotion/list`, data)
	},
	createOneTimeDiscountDoc: function (data) {
		return ApiService.post(`/warehouse-document/create`, data)
	},
	editOneTimeDiscountDoc: function (data) {
		return ApiService.post(`/warehouse-document/edit/discount/with-list`, data)
	},
	buyXGetYPromos: function (data) {
		return ApiService.post(`/promotion/list-Buy-X-Get-Y`, data)
	},

	/**
	 *  get promo by id
	 * @param id
	 * @returns {*}
	 */
	getPromo: function (id) {
		return ApiService.get(`/promotion/get/${id}`)
	},
	getPromotionById(payload) {
		return ApiService.post(`/promotion/edit`, payload)
	},
	getPromotionTabById(payload) {
		return ApiService.post(`/promotion/edit`, payload)
	},
	getPromotionForBarcode(payload) {
		return ApiService.post(`/promotion/price-for-barcode`, payload)
	},
	getBuyXGetYPromotionById(payload) {
		return ApiService.post(`/promotion/edit-buy-X-get-Y`, payload)
	},
	deletePromo: function (id) {
		return ApiService.delete(`/promotion/delete/${id}`)
	},
	deletePromoTab: function (id) {
		return ApiService.delete(`/warehouse-document/delete/${id}`)
	},
	getDepartments: function () {
		return ApiService.post(`/promotion/get-department/`)
	},
	searchDoubleDiscount: function (data) {
		return ApiService.post(`/promotion/view-promotion/`, data)
	}


};

export default PromoService;
